// 本地开发
// let host = `http://192.168.0.113:8888/wj`;

// 线上地址
let host = `https://sc.ai-learning.net/wj`;
// let host = `/wj`;

export default {
	host,
	publicinfo: {
		// 本地开发
		//  webhost: "http://192.168.0.113:8888/wj", //注、意包含应用程序名称
		// 线上地址
		webhost: `https://sc.ai-learning.net/wj`,
		// webhost : `/wj`
	},
	service: {
		// 登录
		login: `${host}/api/user/login.servlet`, //电访登录
		loginOut: `${host}/api/user/loginOut.servlet`, //电访退出
		// 公共项目查询
		ProjectUserList: `${host}/api/projectuser/queryProjectUserList.servlet`, //查询访员关联的项目
		getDialInfo: `${host}/api/dial/getDialInfo.servlet`, //获取电话对象者信息
		queryDaoTimePromissoryInterviewList: `${host}/api/projectuser/queryDaoTimePromissoryInterviewList.servlet`, //查询快到时间的约访记录
		
		// 工作台
		huaQiNewTask: `${host}/api/dialTask/huaQiNewTask.servlet`, // 华旗国产拨号
		huaQiDropCall: `${host}/api/dialTask//huaQiDropCall.servlet`, // 华旗国产拨号挂断
		queryOneSample: `${host}/api/projectuser/queryOneSampleMap.servlet`, //根据样本id查询样本详情
		extractOneSample: `${host}/api/projectuser/extractOneSample.servlet`, //随机抽取样本
		queryOneSampleInterviewlog: `${host}/api/projectuser/queryOneSampleInterviewlog.servlet`, //根据样本编号查询所以历史拨打记录信息
		addSamplePromissoryInterview: `${host}/api/projectuser/addSamplePromissoryInterview.servlet`, //添加样本约访记录
		addSampleInterviewlog: `${host}/api/projectuser/addSampleInterviewlog.servlet`, //添加样本拨打记录
		createSampleInterviewlog: `${host}/api/projectuser/createSampleInterviewlog.servlet`, //添加样本拨打记录
		updatesampleInterviewstatus: `${host}/api/projectuser/updatesampleInterviewstatus.servlet`, //挂断电话更新访问记录表
		updatesampleInterviewstatusBycondition: `${host}/api/projectuser/updatesampleInterviewstatusBycondition.servlet`, // 国产化挂断电话更新访问记录表
		queryPageList: `${host}/api/projectInterviewState/queryPageList.servlet`, //挂电话选择电话状态
		verifyQuota: `${host}/api/projectSample/verifyQuota.servlet`, //挂断电话选择电话状态
		updateSample: `${host}/api/projectSample/updateSample.servlet`, //修改样本扩展信息
		preReadSample: `${host}/api/projectuser/preReadSample.servlet`,
		hqExtCheckIn: `${host}/api/dial/hqExtCheckIn.servlet`,
		// 约访记录
		visit: `${host}/api/projectuser/queryPromissoryInterviewList.servlet`, //根据项目查询访员自己约访记
		updateState: `${host}/api/projectuser/updatePromissoryInterviewState.servlet`, //修改约访回拨
		// 稍后再拨
		queryCallLaterRecordList: `${host}/api/projectuser/queryCallLaterRecordList.servlet`, //根据项目查询访员自己稍后回拨列表
		updatesampleInterview: `${host}/api/projectuser/updatesampleInterview.servlet`, //更新样本
		putItBackOneSample: `${host}/api/projectuser/putItBackOneSample.servlet`, //根据样本编号放回样本
		checkSample: `${host}/api/projectuser/checkSample.servlet`, //获取之前
	
		// 样本报表
		statisticsInterviewlog: `${host}/api/projectuser/statisticsInterviewlog.servlet`, //访问数据统计  今日数据、昨日数据、总数据
		querySampleStatisticsChart: `${host}/api/projectuser/querySampleStatisticsChart.servlet`, //样本统计返回图表接口
		querySampleDtoListList: `${host}/api/projectuser/querySampleDtoListList.servlet`, //样本统计详情列表接口
		querySampleDtoSsIDList: `${host}/api/projectuser/querySampleDtoSsIDList.servlet`, //查询访员的所有样本状态
	}
}
